/*-----------------------------------------------------------------
- forms translations
-----------------------------------------------------------------*/
export default {
    name   : 'نام و نام خانوادگی',
    email  : 'آدرس ایمیل',
    message: 'متن پیام',
    submit : 'فرستادن دیدگاه',
    title  : 'عنوان',
};
